import dayjs from 'dayjs';
import { SET_PERSONAL_CONFIGURATION, SET_GLOBAL_PERIOD } from 'src/store/actions/personalConfigActions';

const defaultGlobalPeriod = {
  startDate: dayjs().startOf('month').format('DD-MM-YYYY'),
  endDate: dayjs().endOf('month').format('DD-MM-YYYY')
};

export const getGlobalPeriod = () => {
  const storageConfig = localStorage.getItem('GlobalPeriod');
  if (storageConfig) {
    return JSON.parse(storageConfig);
  } else {
    return defaultGlobalPeriod;
  }
};

const setGlobalPeriod = (config) => localStorage.setItem('GlobalPeriod', JSON.stringify(config));

const defaultConfig = {
  showMenuSearch: false,
  showGlobalPeriod: false,
  hideNotifications: false,
  globalPeriod: getGlobalPeriod()
};

export const getPersonalConfiguration = () => {
  const storageConfig = localStorage.getItem('PersonalConfigurationModule');
  if (storageConfig) {
    return JSON.parse(storageConfig);
  } else {
    return defaultConfig;
  }
};

const setConfig = (config) => localStorage.setItem('PersonalConfigurationModule', JSON.stringify(config));


const initialState = defaultConfig;

const personalConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERSONAL_CONFIGURATION: {
      setConfig(action.payload);
      return { ...state, ...action.payload };
    }
    case SET_GLOBAL_PERIOD: {
      setGlobalPeriod(action.payload);
      return { ...state, globalPeriod: action.payload };
    }
    default: return state;
  }
};

export default personalConfigurationReducer;
